import { render, staticRenderFns } from "./AddFacilityLocationSetup.vue?vue&type=template&id=679d0e87&scoped=true"
import script from "./AddFacilityLocationSetup.vue?vue&type=script&lang=js"
export * from "./AddFacilityLocationSetup.vue?vue&type=script&lang=js"
import style0 from "./AddFacilityLocationSetup.vue?vue&type=style&index=0&id=679d0e87&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "679d0e87",
  null
  
)

export default component.exports